module.exports = __webpack_public_path__ + "img/msjs-white.fa84241d.svg";